export default __webpack_public_path__ + "static/media/LoserResult.7546bd4f.svg";